<template>
    <div class="section-desc-column">
        <div class="column-container">
            <div class="col-left">
                <div class="desc-html"><strong v-for="(item, index) in options[0].desc_left" :key="index" v-html="item.desc"></strong></div>
            </div>
            <div class="col-right">
                <div class="desc-html"><p v-for="(item, index) in options[0].desc_right" :key="index" v-html="item.desc"></p></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'section-desc-column',
        props: ['options'],
        data () {
            return {
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/partials/section-desc-column.scss';
    @import '@/styles/components/partials/respond/section-desc-column-respond.scss';
</style>